import { selectLoading } from "modules/notification";
import { getDealerStockoutByModelData } from "modules/reporting/redux";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import StockoutModelPanel from './stockoutModelPanel.component';

export default function StockoutModelPanelContainer({
    currentFilter,
    urlDealerStockoutModel,
    translate,
    pageType
}) {
    const dispatch = useDispatch();

    // (1) stockout model data -- start
    const isFetchingDealerStockoutByModel = useSelector(state => selectLoading(state, getDealerStockoutByModelData.typePrefix));
    const dealerStockoutByModelData = useSelector(state => state.reporting.stockout.dealer.stockoutByModelData);
    // (1) stockout model data -- end

    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 10,
        search: "",
        searchBy: "name",
        orderBy: "stockout_count",
        orderDirection: "desc",
    })

    useEffect(() => {
        dispatch(getDealerStockoutByModelData({
            length: tableFilter.rowsPerPage,
            start: tableFilter.page * tableFilter.rowsPerPage,
            orderBy: tableFilter.orderBy,
            orderDirection: tableFilter.orderDirection,
            search: tableFilter.search,
            searchBy: tableFilter.searchBy,
            branch_uuid: currentFilter.branchUuid,
            category_uuid: currentFilter.categoryUuid,
            brand_uuid: currentFilter.brandUuid,
            model_uuid: currentFilter.modelUuid,
            product_uuid: currentFilter.productUuid,
            period: currentFilter.period,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            url: urlDealerStockoutModel
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, tableFilter, currentFilter]);

    const handleChangePage = (e, newPage) => {
        setTableFilter((prev) => ({
          ...prev,
          page: newPage,
        }))
    }

    const handleChangeRowPerPage = (event) => {
        setTableFilter((prev) => ({
          ...prev,
          page: 0,
          rowsPerPage: event.target.value
        }))
    }

    const handleRequestSort = (event, property) => {
        const isAsc = tableFilter.orderBy === property && tableFilter.orderDirection === 'asc';
        setTableFilter((prev) => ({
            ...prev,
            orderDirection: isAsc ? 'desc' : 'asc',
            orderBy: property,
        }))
    }

    return (
        <StockoutModelPanel
        
            status={{
                isFetchingDealerStockoutByModel
            }}

            data={{
                dealerStockoutByModelData
            }}

            sort={{
                valueToOrderBy: tableFilter.orderBy,
                orderDirection: tableFilter.orderDirection,
                handleRequestSort: handleRequestSort,
            }}

            pagination={{
                handleChangePage: handleChangePage,
                handleChangeRowPerPage: handleChangeRowPerPage,
                page: tableFilter.page,
                rowsPerPage: tableFilter.rowsPerPage,
                rowsPerPageOptions: [5, 10, 25],
            }}

            currentFilter={currentFilter}
            translate={translate}
            pageType={pageType}
        />
    )
}